'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _class;
var _row = require('../row');
var _row2 = _interopRequireDefault(_row);
var _accessors = require('./accessors');
var _accessors2 = _interopRequireDefault(_accessors);
var _computors = require('./computors');
var _computors2 = _interopRequireDefault(_computors);
var _eauors = require('./eauors');
var _eauors2 = _interopRequireDefault(_eauors);
var _utils = require('../utils/');
var utils = _interopRequireWildcard(_utils);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StackedRowChart = (0, _accessors2.default)(_class = (0, _computors2.default)(_class = (0, _eauors2.default)(_class = function (_RowChart) {
  (0, _inherits3.default)(StackedRowChart, _RowChart);
  function StackedRowChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    var getAxisOptions = arguments[4];
    (0, _classCallCheck3.default)(this, StackedRowChart);
    var _data = StackedRowChart.computors.stackedData(data);
    var _options = StackedRowChart.computors.computeOptions(options, data);
    var _this = (0, _possibleConstructorReturn3.default)(this, (StackedRowChart.__proto__ || (0, _getPrototypeOf2.default)(StackedRowChart)).call(this, el, _options, _data, getInitialOptions, getAxisOptions));
    _constructor(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      computors: _this.constructor.computors,
      eauors: _this.constructor.eauors
    });
    return _this;
  }
  (0, _createClass3.default)(StackedRowChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];
      var getAxisOptions = arguments[4];
      var _data = StackedRowChart.computors.stackedData(data);
      var _options = StackedRowChart.computors.computeOptions(options, data);
      (0, _get3.default)(StackedRowChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(StackedRowChart.prototype), 'update', this).call(this, el, _options, _data, getInitialOptions, getAxisOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      });
    }
  }]);
  return StackedRowChart;
}(_row2.default)) || _class) || _class) || _class;
exports.default = StackedRowChart;
function _constructor(el, options, data, ors) {
  utils.noElError(el);
  _update(el, options, data, ors);
}
function _update(el, options, data, ors) {
  var yAxisLabelJoin = d3.select(el).select(utils.selector(ors.selectors.yAxis)).selectAll('text').data(ors.computors.nonStackedData(data));
  yAxisLabelJoin.call(ors.eauors.yAxisLabelUpdate, options.serie, ors.accessors);

  // multi bars per serie caused a bad data binding in row chart, this is needed to have a good label serie coloring ...
}